import { Box, Container, List, ListItem, ListItemText, Typography } from '@mui/material';

import type { ListBlockContent } from '@/types/database';

export function ListBlockView({ content }: { content: ListBlockContent }) {
  const items = content.items || [];

  return (
    <Box sx={{ py: 6 }}>
      <Container maxWidth="sm">
        {content.heading ? (
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
            {content.heading}
          </Typography>
        ) : null}
        <List dense={content.dense} disablePadding>
          {items.map((item, index) => (
            <ListItem key={index} disableGutters sx={{ display: 'list-item', pl: 3, listStyleType: 'disc' }}>
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>
      </Container>
    </Box>
  );
}
